module.exports = __webpack_public_path__ + "img/sunset.73031c87.jpg";